import { defineComponent, inject } from '@vue/composition-api';
import { usePageletEvent, EVENTS } from '@composables/usePageletEvent';
import { DEFAULT_LESSCODE } from '@components/CodeEditor/utils/codes';
import styles from './index.module.scss';
const XyNavContainer = defineComponent({
    name: 'XyNavContainer',
    setup(props, { emit }) {
        usePageletEvent({ emit });
        const w = inject('w', null);
        const getDefaultSlot = () => {
            if (w?.mode === 'runtime')
                return null;
            return (<div class={styles.placeholder}>
        <span>请放置组件</span>
      </div>);
        };
        return {
            getDefaultSlot,
        };
    },
    render() {
        return (<div class={['xy-nav-container', styles.container]}>
        {this.$slots.default || this.getDefaultSlot()}
      </div>);
    },
});
const componentId = 'xy-nav-container';
export const getDefaultNavConfig = (id) => ([
    {
        id,
        name: '导航',
        layout: {
            type: componentId,
            props: {},
            children: [],
            style: {
                height: '56px',
                'background-color': 'rgba(255, 255, 255, 1)',
            },
        },
        xyType: 'pagelet',
        lessCode: DEFAULT_LESSCODE,
    },
]);
export default {
    component: XyNavContainer,
    componentForDesign: XyNavContainer,
    category: '组合',
    id: componentId,
    slots: [
        { id: 'default', selector: '.xy-nav-container' },
    ],
    events: EVENTS,
    display: 'block',
    visible: false,
    name: '导航栏',
    propsSchema: {
        type: 'object',
        fields: [],
    },
    readme: '',
};
